import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import type { DecorationSet } from '@atlaskit/editor-prosemirror/view';

export type SlashRemixPlaceholderState = { decorations: DecorationSet };

export type RemixSlashFormat = 'bar-chart';

export type SlashRemixPlaceholderAction =
	| { format: RemixSlashFormat; type: 'open' }
	| { type: 'remove' };

export const slashRemixPlaceholderKey: PluginKey<SlashRemixPlaceholderState> =
	new PluginKey<SlashRemixPlaceholderState>('slashRemixPlaceholder');
